import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const getHomeList = catchAsync(async () => {
  const { data } = await axiosInstance.get('/home');
  return data;
});
export const getProjects = catchAsync(async () => {
  const { data } = await axiosInstance.get('/projects');
  return data;
});
export const getProject = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(`/projects/${id}`);
  return data;
});
export const getServices = catchAsync(async () => {
  const { data } = await axiosInstance.get('/services');
  return data;
});
export const getAbout = catchAsync(async () => {
  const { data } = await axiosInstance.get('/about/us');
  return data;
});
export const getSettings = catchAsync(async () => {
  const { data } = await axiosInstance.get('/settings');
  return data;
});
